module.exports = __webpack_public_path__ + "static/media/iphonexsmax_splash.01e0f2f9.png";